<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7"></div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" footer-classes="pt-1">
          <template slot="header">
            <div class="row align-items-center">
              <div class="col-md-6 col-lg-6">
                <h2 class="mb-0">Course/ TABC Report</h2>
              </div>

              <div class="col-lg-6 col-md-6 text-right">
                <base-button class="custom-btn" v-on:click="resetFilters()"
                  ><i class="fa fa-refresh" aria-hidden="true"></i> Clear
                  Filters</base-button
                >

                <base-button
  class="custom-btn"
  @click="exportExcel"
  :disabled="loadingExport"
>
  <span v-if="loadingExport">
    <i class="fa fa-spinner fa-spin"></i> Generating Excel...
  </span>
  <span v-else>Excel Download</span>
</base-button>

              </div>
            </div>
          </template>

          <div>
            <div
              class="row d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-md-3">
                <base-input
                  label="Search:"
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search Keyword"
                >
                </base-input>
              </div>

              <div class="col-md-3">
                <base-input label="Date Range">
                  <el-date-picker
                    v-on:change="changePage(1)"
                    v-model="filters.report_date"
                    type="daterange"
                    unlink-panels
                    style="width:100%"
                    value-format="MM/dd/yyyy"
                    range-separator="-"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    @change="handleDateChange"
                  >
                  </el-date-picker>
                </base-input>
              </div>
              <div class="col-md-3">
                <base-input label="Course" placeholder="Select Course">
                  <el-select
                    filterable
                    v-on:change="fetchData()"
                    class="select-primary"
                    v-model="filters.course_id"
                  >
                    <el-option
                      class="select-Select Action"
                        label="Tabc"
                        value="TABC"
                    >
                    </el-option>
                    <el-option
                      class="select-Select Action"
                        label="Tabc (Spanish)"
                        value="TABC (Spanish)"
                    >
                    </el-option>
                    <el-option
                      class="select-Select Action"
                        label="Both"
                        value="Both"
                    >
                    </el-option>
                  </el-select>
                </base-input>
              </div>
              <div
                class="col-md-3 form-group"
              >
                <!-- style="margin-left:0px !important; /" -->
                <label class="form-control-label">User Status:</label>
                <el-select
                  class="select-primary"
                  v-model="filters.employeStatus"
                  v-on:change="changePage(1)"
                  placeholder="Filter by status"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
            </div>
              <div class="col-md-3 form-group" v-if="showUserTypeFilter">
                <label class="form-control-label">User Type:</label>
                <el-select
                  class="select-primary"
                  v-model="filters.user_type"
                  v-on:change="changePage(1)"
                  placeholder="Filter by user type"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in userTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>

            </div>
            <div
              class="
                row
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
            
            </div>
            <div class="user-eltable">
              <el-table
                role="table"
                :data="tableData"
                stripe
                highlight-current-row
                lazy
                row-key="id"
                id="tableOne"
                header-row-class-name="thead-light"
                class="failPassGrid table-striped"
              >

              <el-table-column min-width="80px" prop="last_name">
                  <template slot="header">
                    <span
                      >Social Security

                    </span>
                  </template>
                  <template slot-scope="props">
                    {{ props.row.social_security }}
                  </template>
                </el-table-column>

                <el-table-column min-width="80px" prop="last_name">
                  <template slot="header">
                    <span @click="sortByColumn(1)"
                      >Last Name
                      <i
                        v-if="sortedColumn == 1 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    {{ props.row.last_name }}
                  </template>
                </el-table-column>

                <el-table-column min-width="80px" prop="first_name">
                  <template slot="header">
                    <span @click="sortByColumn(2)"
                      >First Name
                      <i
                        v-if="sortedColumn == 2 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    {{ props.row.first_name }}
                  </template>
                </el-table-column>



                <el-table-column min-width="80px" prop="dob">
                  <template slot="header">
                    <span
                      >DOB

                    </span>
                  </template>
                  <template slot-scope="props">
                    {{ props.row.dob }}
                  </template>
                </el-table-column>



                <!-- <el-table-column min-width="100px">
                  <template slot="header">
                    <span @click="sortByColumn(2)"
                      >Location
                      <i
                        v-if="sortedColumn == 2 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span v-if="props.row.location">
                      {{ props.row.location }}</span
                    >
                    <span v-else> -</span>
                  </template>
                </el-table-column> -->
                <el-table-column min-width="80px">
                  <template slot="header"> Score </template>
                  <template slot-scope="props">
                    {{ props.row.percentage }}
                  </template>
                </el-table-column>

                <el-table-column min-width="100px">
                  <template slot="header">
                    <span @click="sortByColumn(5)"
                      >Certificate Number
                      <i
                        v-if="sortedColumn == 5 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span v-if="props.row.certificate_number !== 'Invalid date'">
                      {{ props.row.certificate_number }}</span
                    >
                    <span v-else> -</span>
                  </template>
                </el-table-column>

                <el-table-column min-width="100px">
                  <template slot="header">
                    <span @click="sortByColumn(6)"
                      >Course
                      <i
                        v-if="sortedColumn == 6 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span v-if="props.row.course_name">
                      {{ props.row.course_name }}</span
                    >
                    <span v-else> -</span>
                  </template>
                </el-table-column>

                <el-table-column min-width="80px">
                  <template slot="header">
                    <span @click="sortByColumn(7)"
                      >Status
                      <i
                        v-if="sortedColumn == 7 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.course_status }}</span>
                  </template>
                </el-table-column>



                <el-table-column min-width="100px">
                  <template slot="header">
                    <span @click="sortByColumn(8)"
                      >Completion Date
                      <i
                        v-if="sortedColumn == 8 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      /><i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span v-if="props.row.completion_date !== 'Invalid date'">
                      {{ props.row.completion_date }}</span
                    >
                    <span v-else> -</span>
                  </template>
                </el-table-column>

              </el-table>
            </div>
          </div>
          <div slot="footer" class="d-flex justify-content-end">
            <nav v-if="pagination && tableData.length > 0">
              <div class="row">
                <div class="col-md-12">
                  <ul
                    class="pagination custompagination justify-content-end align-items-center"
                  >
                  <p class="p-0 m-0 mr-2 d-flex align-items-center">
  <span class="mr-1">Showing</span>

  <el-select
    class="select-primary pagination-select mx-1"
    v-model="perPage"
    @change="changePage(1)"
    placeholder="Per page"
    size="mini"
    style="width: auto; display: inline-block;"
  >
    <el-option
      class="select-primary"
      v-for="item in perPageOptions"
      :key="item"
      :label="item"
      :value="item"
    ></el-option>
  </el-select>

  <span class="ml-1">of {{ totalData }} entries</span>
</p>

                    <li
                      class="page-item"
                      :class="{ disabled: currentPage === 1 }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="changePage(currentPage - 1)"
                        ><i class="fa fa-caret-left"></i>
                      </a>
                    </li>
                    <li
                      v-for="(page, index) in pagesNumber"
                      class="page-item"
                      :class="{ active: page == currentPage }"
                      v-bind:key="index"
                    >
                      <a
                        href="javascript:void(0)"
                        @click.prevent="changePage(page)"
                        class="page-link"
                        >{{ page }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: currentPage === last_page,
                      }"
                    >
                      <a
                        class="page-link"
                        href="#"
                        @click.prevent="changePage(currentPage + 1)"
                        ><i class="fa fa-caret-right"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </card>
      </div>
    </div>

    <!-- OTP Verification Modal -->
    <Modal :show.sync="showOtpModal" modal-classes="modal-dialog-centered modal-md">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">OTP Verification</h5>
      </template>
      <div class="otp-verification-container">
        <div class="otp-step">
          <div class="otp-icon-wrapper">
            <i class="fas fa-lock"></i>
          </div>
          <h4 style="text-align: center; margin-top: 20px; color: #2F3133;">
            Enter Verification Code
          </h4>
          <p style="text-align: center; color: #74787e; margin-top: 10px; font-size: 14px;">
            Please enter the 6-digit code sent to support email
          </p>
          <div class="otp-input-wrapper" style="margin-top: 30px;">
            <input
              ref="otpInput"
              v-model="otpCode"
              @input="onOtpInput"
              type="text"
              class="otp-input"
              placeholder="000000"
              maxlength="6"
              autocomplete="off"
            />
          </div>
          <div v-if="otpError" style="margin-top: 15px; text-align: center;">
            <span style="color: #e74c3c; font-size: 13px;">{{ otpError }}</span>
          </div>
          <div style="margin-top: 20px; text-align: center;">
            <button
              @click="resendOTP"
              :disabled="resendingOtp"
              style="background: none; border: none; color: #667eea; cursor: pointer; font-size: 14px; text-decoration: underline;"
            >
              <span v-if="resendingOtp">
                <i class="fa fa-spinner fa-spin"></i> Resending...
              </span>
              <span v-else>Resend OTP</span>
            </button>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="closeOtpModal">Cancel</base-button>
        <base-button
          type="primary"
          class="btn-verify"
          @click="verifyOTP"
          :disabled="verifyingOtp || otpCode.length !== 6"
        >
          <span v-if="verifyingOtp">
            <i class="fa fa-spinner fa-spin"></i> Verifying...
          </span>
          <span v-else>Verify & Download</span>
        </base-button>
      </template>
    </Modal>

  </div>
</template>
<script>
import { DatePicker, Option, Select, Table, TableColumn } from "element-ui";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import XLSX from "xlsx";
import moment from "moment";
import { Modal } from "@/components";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

let timeout = null;
export default {
  name: "companies",
  mixins: [serverSidePaginationMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Modal,
  },
  data() {
    return {
      loadingExport: false,
      loading: false,
      locations: [
        {
          label: "All",
          value: "",
        },
      ],
      coursesList: [
        {
          label: "All",
          value: "",
        },
      ],
      searchQuery: "",

      filters: {
        location_id: "",
        course_id: "Both",
        report_date: [],
        employeStatus: 2,
        user_type: "",
      },
      userTypeOptions: [
        { label: "All", value: "" },
        { label: "Individual", value: "individual" },
        { label: "Company", value: "company" },
      ],
      showUserTypeFilter: ["super-admin", "sub-admin"].includes(localStorage.getItem("hot-user")),
      status: [
        {
          label: "All",
          value: 2,
        },
        {
          label: "Active",
          value: 1,
        },
        {
          label: "Inactive",
          value: 0,
        },
      ],
      tableData: [],
      editor: "",
      totalData: "",
      sortedColumn: 9,
      order: "desc",
      // OTP Verification
      showOtpModal: false,
      otpCode: "",
      otpToken: "",
      otpError: "",
      sendingOtp: false,
      verifyingOtp: false,
      resendingOtp: false,
    };
  },
  watch: {
    searchQuery: function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.fetchData();
      }, 300);
    },
  },
  created: function () {
    if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    }
    if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
    }
    this.$http
      .post("location/all_company_location", {
        role: this.editor,
      })
      .then((resp) => {
        for (let loc of resp.data) {
          let obj = {
            label: loc.name,
            value: loc.id,
          };
          this.locations.push(obj);
        }
      });
    this.$http
      .post("course/all_courses", {
        course_status: "Active",
      })
      .then((resp) => {
        let courses = resp.data.courses;
        for (let course of courses) {
          let obj = {
            value: course.id,
            label: course.name,
          };

          this.coursesList.push(obj);
        }
      })
      .finally(() => (this.loading = false));
    this.fetchData();
  },
  methods: {
    resetFilters() {
      this.searchQuery = "";
      this.filters.location_id = "";
      this.filters.course_id = "";
      this.filters.report_date = "";
      this.filters.employeStatus = 2;
      this.filters.user_type = "";
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      this.$http
        .post("course/tabc-report", {
          search: this.searchQuery,
          page: this.currentPage,
          column: this.sortedColumn,
          per_page: this.perPage,
          order: this.order,
          company_id: this.filters.location_id,
          course_id: this.filters.course_id,
          status: this.filters.employeStatus,
          report_date: this.filters.report_date,
          user_type: this.filters.user_type,

        })
        .then((resp) => {
          this.tableData = [];
          let report_data = resp.data.report;
          let total_data = resp.data.total;
          this.totalData = total_data;
          for (let data of report_data) {
            let obj = {
              id: data.id,
              first_name: data.first_name,
              last_name: data.last_name,
              course_name: data.course_name,
              completion_date: this.formatDate(data.employee_course_date_completed),
              course_status: data.pass_fail_status,
              location: data.company_name,
              percentage: data.percentage,
              certificate_number : data.certificate_number,
              social_security : data.encrypt_ssn,
              dob : this.formatDate(data.dob)
            };

            this.tableData.push(obj);
          }
        })
        .finally(() => (this.loading = false));
    },
  handleDateChange(value) {
    if (value && value.length === 2) {
      this.filters.report_date = `${this.formatDate(value[0])}-${this.formatDate(value[1])}`;
    } else {
      this.filters.report_date = "";
    }
  },
  formatDate(date) {
    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
  },
  exportExcel() {
    // Reset OTP modal state
    this.otpCode = "";
    this.otpToken = "";
    this.otpError = "";
    this.showOtpModal = true;
    // Automatically send OTP when modal opens
    this.sendOTP();
  },
  closeOtpModal() {
    this.showOtpModal = false;
    this.otpCode = "";
    this.otpToken = "";
    this.otpError = "";
  },
  sendOTP() {
    this.sendingOtp = true;
    this.otpError = "";
    this.$http
      .post("download/tabc/send-otp", {})
      .then((resp) => {
        // Handle successful response
        const responseData = resp.data;
        const otpToken = responseData?.otp_token;
        
        if (otpToken) {
          this.otpToken = otpToken;
          Swal.fire({
            title: "Success!",
            text: responseData.message || "Email has been sent to the support",
            icon: "success",
            timer: 2000,
            showConfirmButton: false
          });
          // Focus on OTP input
          this.$nextTick(() => {
            if (this.$refs.otpInput) {
              this.$refs.otpInput.focus();
            }
          });
        } else {
          // Even if no token, if message says success, treat as success
          if (responseData?.message && responseData.message.toLowerCase().includes("success")) {
            this.otpToken = responseData.otp_token || "";
            Swal.fire({
              title: "Success!",
              text: responseData.message,
              icon: "success",
              timer: 2000,
              showConfirmButton: false
            });
            this.$nextTick(() => {
              if (this.$refs.otpInput) {
                this.$refs.otpInput.focus();
              }
            });
          } else {
            this.otpError = "Invalid response from server";
            Swal.fire({
              title: "Error!",
              text: this.otpError,
              icon: "error"
            });
          }
        }
      })
      .catch((error) => {
        // Handle error - but check if response contains success data
        const responseData = error.response?.data;
        
        // If error response has otp_token, treat as success (might be CORS or status code issue)
        if (responseData && responseData.otp_token) {
          this.otpToken = responseData.otp_token;
          Swal.fire({
            title: "Success!",
            text: responseData.message || "Email has been sent to the support",
            icon: "success",
            timer: 2000,
            showConfirmButton: false
          });
          this.$nextTick(() => {
            if (this.$refs.otpInput) {
              this.$refs.otpInput.focus();
            }
          });
        } else {
          // Real error
          const errorMessage = responseData?.message || error.message || "Failed to send OTP. Please try again.";
          this.otpError = errorMessage;
          Swal.fire({
            title: "Error!",
            text: errorMessage,
            icon: "error"
          });
        }
      })
      .finally(() => {
        this.sendingOtp = false;
      });
  },
  resendOTP() {
    this.resendingOtp = true;
    this.otpCode = "";
    this.otpError = "";
    this.otpToken = "";
    this.$http
      .post("download/tabc/send-otp", {})
      .then((resp) => {
        // Check for otp_token in response data - handle different response structures
        const responseData = resp.data || resp;
        const otpToken = responseData.otp_token || responseData.data?.otp_token;
        
        if (otpToken) {
          this.otpToken = otpToken;
          Swal.fire({
            title: "Success!",
            text: responseData.message || "OTP has been resent to support email",
            icon: "success",
            timer: 2000,
            showConfirmButton: false
          });
          // Focus on OTP input
          this.$nextTick(() => {
            if (this.$refs.otpInput) {
              this.$refs.otpInput.focus();
            }
          });
        } else {
          // If no token but response exists, still show success if message indicates success
          if (responseData.message && responseData.message.includes("successfully")) {
            this.otpToken = responseData.otp_token || "";
            Swal.fire({
              title: "Success!",
              text: responseData.message,
              icon: "success",
              timer: 2000,
              showConfirmButton: false
            });
            this.$nextTick(() => {
              if (this.$refs.otpInput) {
                this.$refs.otpInput.focus();
              }
            });
          } else {
            this.otpError = "Invalid response from server";
            Swal.fire({
              title: "Error!",
              text: this.otpError,
              icon: "error"
            });
          }
        }
      })
      .catch((error) => {
        // Check if it's actually a successful response that was caught as error
        const responseData = error.response?.data || error.data;
        if (responseData && responseData.otp_token) {
          // Response was successful but caught as error (might be status code issue)
          this.otpToken = responseData.otp_token;
          Swal.fire({
            title: "Success!",
            text: responseData.message || "OTP has been resent to support email",
            icon: "success",
            timer: 2000,
            showConfirmButton: false
          });
          this.$nextTick(() => {
            if (this.$refs.otpInput) {
              this.$refs.otpInput.focus();
            }
          });
        } else {
          this.otpError = error.response?.data?.message || "Failed to resend OTP. Please try again.";
          Swal.fire({
            title: "Error!",
            text: this.otpError,
            icon: "error"
          });
        }
      })
      .finally(() => {
        this.resendingOtp = false;
      });
  },
  onOtpInput(event) {
    // Only allow numbers
    this.otpCode = event.target.value.replace(/\D/g, "");
    this.otpError = "";
  },
  verifyOTP() {
    if (this.otpCode.length !== 6) {
      this.otpError = "Please enter a 6-digit code";
      return;
    }

    this.verifyingOtp = true;
    this.otpError = "";
    
    this.$http
      .post("download/tabc/verify-otp", {
        otp: this.otpCode,
        otp_token: this.otpToken,
      })
      .then((resp) => {
        // OTP verified, proceed with download
        this.downloadFile();
        this.closeOtpModal();
        Swal.fire({
          title: "Success!",
          text: "OTP verified successfully. Download started.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });
      })
      .catch((error) => {
        this.otpError = error.response?.data?.message || "Invalid OTP. Please try again.";
        Swal.fire({
          title: "Error!",
          text: this.otpError,
          icon: "error"
        });
      })
      .finally(() => {
        this.verifyingOtp = false;
      });
  },
  downloadFile() {
    const params = new URLSearchParams({
      search: this.searchQuery,
      page: this.currentPage,
      column: this.sortedColumn,
      per_page: this.perPage,
      order: this.order,
      company_id: this.filters.location_id,
      course_id: this.filters.course_id,
      status: this.filters.employeStatus,
      report_date: this.filters.report_date,
      user_type: this.filters.user_type,
      isExcelDownload: true,
      otp_token: this.otpToken,
    }).toString();

    // Get the API URL from the environment variable
    const baseUrl = process.env.VUE_APP_API_URL;

    // Construct the URL
    const url = `${baseUrl}/download/tabc/csv?${params}`;

    // Open the URL to trigger the download
    window.open(url, "_blank");
  },
  },
};
</script>
<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}
.pagination-select {
  display: inline-block !important;
  width: auto !important;
}
.pagination-select >>> .el-input {
  width: auto !important;
}
.pagination-select >>> .el-input__inner {
  width: auto !important;
  padding: 0 20px 0 6px !important;
  height: 28px !important;
  line-height: 28px !important;
  font-size: 13px !important;
  min-width: auto !important;
}
.pagination-select >>> .el-input__suffix {
  right: 5px;
}

/* OTP Verification Modal Styles */
.otp-verification-container {
  padding: 10px 0;
}

.otp-step {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.otp-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.otp-icon-wrapper i {
  font-size: 32px;
  color: white;
}

.otp-input-wrapper {
  display: flex;
  justify-content: center;
}

.otp-input {
  width: 100%;
  max-width: 280px;
  height: 60px;
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  letter-spacing: 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  outline: none;
  transition: all 0.3s ease;
  font-family: 'Courier New', monospace;
  color: #2F3133;
}

.otp-input:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.otp-input::placeholder {
  letter-spacing: 8px;
  color: #b0b0b0;
}

.btn-verify {
  height: 45px;
  font-weight: 600;
  font-size: 15px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.btn-verify:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-verify:active {
  transform: translateY(0);
}
@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  .failPassGrid >>> table.el-table__body td:nth-of-type(1):before {
    content: "First Name";
  }
  .failPassGrid >>> table.el-table__body td:nth-of-type(2):before {
    content: "Last Name";
  }
  .failPassGrid >>> table.el-table__body td:nth-of-type(3):before {
    content: "Location";
  }
  .failPassGrid >>> table.el-table__body td:nth-of-type(4):before {
    content: "Course";
  }
  .failPassGrid >>> table.el-table__body td:nth-of-type(5):before {
    content: "Attempt Date";
  }
  .failPassGrid >>> table.el-table__body td:nth-of-type(6):before {
    content: "Status";
  }
  .failPassGrid >>> table.el-table__body td:nth-of-type(7):before {
    content: "Completion Date";
  }
}
</style>